import React from 'react'

import Layout from 'components/shared/Layout'
import Text from 'components/typo/Text'
import HeroTitle from 'components/typo/HeroTitle'

import classnames from 'classnames/bind'
import css from './styles.module.scss'
import ConfiguredFeatureCard from 'src/components/shared/ConfiguredFeatureCard'

const cx = classnames.bind(css)

const FeaturesGrid = ({ upperTitle, title, description, cards }) => {
  return (
    <Layout type="wrapper">
      <div className={css.wrapper}>
        <div className={css.header}>
          <Text className={css.upperTitle}>{upperTitle}</Text>
          <HeroTitle className={css.heroTitle} tag="h2">
            {title}
          </HeroTitle>
          {description && (
            <Text className={css.description}>{description}</Text>
          )}
        </div>
        <div className={css.gridCards}>
          {cards.map((card, index) => (
            <ConfiguredFeatureCard key={index} {...card} index={index} />
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default FeaturesGrid
